export const POSTER_BG = "/poster-bg.jpg";

const uid = () => (crypto?.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2));

const row = (cat, match, time) => ({ id: uid(), cat, match, time, score: "" });
const frow = (cat, match, day, time) => ({ id: uid(), cat, match, day, time, score: "" });

export const newPosterTemplate = () => ({
  name: "Matchs du week-end",
  title: "LES MATCHS DU WEEK-END",
  club_name: "U.S.C JAPPES",
  logo_url: "",
  team_name: "USC",
  highlight_team: true,
  highlight_first_team: true,
  show_scores: false,
  locked: false,
  background_url: "",
  color_primary: "#182f5c",
  color_accent: "#c6a15a",
  columns: [
    {
      id: uid(),
      header: "SAMEDI 03/10",
      rows: [
        row("U6", "BAUDOUR ASC - USC", "10H30"),
        row("U7", "U ST-GHIS.TERTRE-HAUT. - USC", "9H30"),
        row("U8", "US NEUFVILLES B - USC", "11H00"),
        row("U9", "RAFC CUESMES - USC", "10H00"),
        row("U10", "USC - FC QUÉVY GENLY", "9H30"),
        row("U11", "USC - RAJS HONNELOISE", "11H00"),
        row("U16", "USC - U ST-GHIS.TERTRE-HAUT.", "F.G."),
        row("U17", "USC - U ST-GHIS.TERTRE-HAUT.", "13H00"),
        row("U19", "U ST-GHIS.TERTRE-HAUT. - USC", "17H"),
      ],
    },
    {
      id: uid(),
      header: "DIMANCHE 04/10",
      rows: [
        row("U12A", "USC - U ST-GHIS.TERTRE-HAUT.", "9H30"),
        row("U12B", "RAS GHLINOISE - USC", "10H00"),
        row("U13", "USC - RAS GHLINOISE", "9H30"),
        row("U14A", "RAS GHLINOISE - USC", "10H00"),
        row("U14B", "USC - RFC THULIN", "10H00"),
        row("U15", "USC - U ST-GHIS.TERTRE-HAUT.", "10H00"),
      ],
    },
  ],
  footer: [
    frow("P4", "USC - A.S. QUIÉVRAIN", "DIMANCHE", "15H"),
    frow("D3", "P.-À-CEL.-BUZ. - USC", "DIMANCHE", "15H"),
  ],
});

export const newRow = () => row("U00", "ÉQUIPE A - ÉQUIPE B", "00H00");
export const newFooterRow = () => frow("XX", "ÉQUIPE A - ÉQUIPE B", "DIMANCHE", "00H");

export const newUscPoster = () => ({
  ...newPosterTemplate(),
  name: "Matchs du week-end (USC)",
  layout: "usc",
  top: {
    show: true,
    header: "VENDREDI 09/10",
    rows: [row("U13", "C.OL. TRIVIÈRES - USC", "18H00")],
  },
  columns: [
    {
      id: uid(),
      header: "SAMEDI 10/10",
      rows: [
        row("U6", "F.C. VACRESSE - USC", "F.G."),
        row("U7", "USC - F.C. AEDEC HYON", "11H30"),
        row("U8", "USC - BAUDOUR A.S.C.", "9H30"),
        row("U9", "USC - FC BORINA QUAREGNON", "11H00"),
        row("U10", "F.C. AEDEC HYON - USC", "9H30"),
        row("U11", "FC STE ODILE ÉLOUGES - USC", "10H00"),
        row("U16", "R.SP.B. FRAMERIES - USC", "F.G."),
        row("U17", "F.C. QUÉVY - GENLY - USC", "15H"),
        row("U19", "USC - R.U.S. HENSIES", "13H"),
      ],
    },
    {
      id: uid(),
      header: "DIMANCHE 11/10",
      rows: [
        row("U12A", "R.SP.B. FRAMERIES - USC", "11H15"),
        row("U12B", "USC - PHÉ. ACAD.CLUB MONS", "11H00"),
        row("U13", "R.SP.B. FRAMERIES - USC", "9H15"),
        row("U13", "R.SOIGNIES SPORT - USC", "11H30"),
        row("U14A", "USC - R.SP.B. FRAMERIES", "10H00"),
        row("U14B", "R.L.C. HORNU - USC", "9H15"),
        row("U15", "R.A.F.C. CUESMES - USC", "F.G."),
      ],
    },
  ],
  footer: [
    frow("P4", "R.C.S. AULNOIS. - USC", "DIMANCHE", "15H"),
    frow("D3", "USC - R. ARQ.NAMUR", "DIMANCHE", "15H"),
  ],
});

const DAY_RE = /^(LUNDI|MARDI|MERCREDI|JEUDI|VENDREDI|SAMEDI|DIMANCHE)\b/i;
const MATCH_RE = /^(\S+)\s+(.+?)\s+(\d{1,2}\s*H\s*\d{0,2}|F\.?\s*G\.?)\s*$/i;
const SENIOR_RE = /^(P|D|R)\d/i;

export const parseSchedule = (text) => {
  const top = { header: "", rows: [] };
  const cols = [];
  const footer = [];
  let day = null;
  let section = null;
  for (const raw of (text || "").split(/\r?\n/)) {
    const line = raw.replace(/\t+/g, " ").replace(/\s+/g, " ").trim().toUpperCase();
    if (!line) continue;
    const m = line.match(MATCH_RE);
    if (!m) {
      const d = line.match(DAY_RE);
      if (d) {
        day = d[1];
        if (day === "VENDREDI") { top.header = line; section = top; }
        else { section = { id: uid(), header: line, rows: [] }; cols.push(section); }
      }
      continue;
    }
    const [, cat, match, time] = m;
    const t = time.replace(/\s+/g, "");
    if (SENIOR_RE.test(cat)) footer.push(frow(cat, match, day || "DIMANCHE", t));
    else if (section) section.rows.push(row(cat, match, t));
  }
  return { top, cols, footer };
};

const catKey = (c) => {
  const m = (c || "").toUpperCase().match(/^([A-Z]*)(\d*)(.*)$/);
  return [m[1] === "U" ? 0 : 1, m[1], parseInt(m[2] || "999", 10), m[3]];
};
export const sortByCat = (rows = []) =>
  [...rows].sort((a, b) => {
    const x = catKey(a.cat), y = catKey(b.cat);
    for (let i = 0; i < 4; i++) if (x[i] !== y[i]) return x[i] < y[i] ? -1 : 1;
    return 0;
  });
const DAYS = ["LUN", "MAR", "MER", "JEU", "VEN", "SAM", "DIM"];
const dayTimeKey = (t) => {
  const s = (t || "").toUpperCase();
  const d = DAYS.findIndex((x) => s.startsWith(x));
  const m = s.match(/(\d{1,2})H(\d{0,2})/);
  return [d < 0 ? 9 : d, m ? +m[1] * 60 + +(m[2] || 0) : 9999];
};
export const sortByDay = (rows = []) =>
  [...rows].sort((a, b) => {
    const x = dayTimeKey(a.time), y = dayTimeKey(b.time);
    return x[0] - y[0] || x[1] - y[1];
  });
const footKey = (r) => dayTimeKey(`${r.day || ""} ${r.time || ""}`);
export const sortPoster = (d, by = d.band?.sort_by || "cat") => ({
  ...d,
  top: d.top ? { ...d.top, rows: sortByDay(d.top.rows) } : d.top,
  columns: (d.columns || []).map((c) => ({ ...c, rows: by === "time" ? sortByDay(c.rows) : sortByCat(c.rows) })),
  footer: by === "time"
    ? [...(d.footer || [])].sort((a, b) => { const x = footKey(a), y = footKey(b); return x[0] - y[0] || x[1] - y[1]; })
    : sortByCat(d.footer || []),
});

export const newBlankPoster = () => ({
  ...newUscPoster(),
  name: "Nouvelle affiche",
  show_columns: false,
  show_logo: false,
  show_footer: false,
  show_title: false,
  top: { show: false, header: "MATCHS EN SEMAINE", rows: [] },
  columns: [
    { id: uid(), header: "SAMEDI", rows: [] },
    { id: uid(), header: "DIMANCHE", rows: [] },
  ],
  footer: [],
});

export const toResultsPoster = (p) => ({
  ...p,
  name: `${p.name} — Résultats`,
  title: "LES RÉSULTATS DU WEEK-END",
  show_scores: true,
  locked: false,
  source_poster_id: p.id,
});

const FULL_DAYS = ["LUNDI", "MARDI", "MERCREDI", "JEUDI", "VENDREDI", "SAMEDI", "DIMANCHE"];
const isSenior = (r) => SENIOR_RE.test(r.cat || "");
const dayOf = (r) => FULL_DAYS.find((d) => (r.day || r.time || "").toUpperCase().startsWith(d.slice(0, 3))) || "DIMANCHE";

export const splitAcademySeniors = (p) => {
  const top = p.top || { rows: [] };
  const seniors = [
    ...(p.footer || []),
    ...(top.rows || []).filter(isSenior),
    ...(p.columns || []).flatMap((c) => c.rows.filter(isSenior).map((r) => ({ ...r, day: c.header }))),
  ];
  const headers = [top.header, ...(p.columns || []).map((c) => c.header)].filter(Boolean);
  const weekend = (r) => ["SAMEDI", "DIMANCHE"].includes(dayOf(r));
  const weekRows = seniors.filter((r) => !weekend(r)).map((r) => row(r.cat, r.match, `${dayOf(r).slice(0, 3)} ${(r.time || "").replace(/^(LUN|MAR|MER|JEU|VEN|SAM|DIM)[A-Z]*\.?\s*/i, "")}`.trim()));
  const academy = {
    ...p, name: `${p.name} — Académie`, title: "LES MATCHS DE L'ACADÉMIE", footer: [], show_footer: false,
    top: { ...top, rows: (top.rows || []).filter((r) => !isSenior(r)) },
    columns: (p.columns || []).map((c) => ({ ...c, rows: c.rows.filter((r) => !isSenior(r)) })),
  };
  const senior = {
    ...p, name: `${p.name} — Seniors`, title: "LES MATCHS SENIORS", footer: [], show_footer: false, show_columns: true,
    band: { ...(p.band || {}), merge_days: false },
    top: { ...top, show: weekRows.length > 0, rows: sortByDay(weekRows) },
    columns: ["SAMEDI", "DIMANCHE"].map((d) => {
      const src = (p.columns || []).find((c) => (c.header || "").toUpperCase().includes(d)) || {};
      return {
        ...(src.dx !== undefined && { dx: src.dx }), ...(src.dy !== undefined && { dy: src.dy }), ...(src.hs && { hs: src.hs }),
        id: src.id || uid(),
        header: src.header || headers.find((h) => h.toUpperCase().includes(d)) || d,
        rows: seniors.filter((r) => dayOf(r) === d).map((r) => row(r.cat, r.match, (r.time || "").replace(/^(LUN|MAR|MER|JEU|VEN|SAM|DIM)[A-Z]*\.?\s*/i, "") || r.time)),
      };
    }),
  };
  return { academy, senior };
};

const allRows = (d) => [...(d.top?.rows || []), ...(d.columns || []).flatMap((c) => c.rows || []), ...(d.footer || [])];
const styleKey = (r) => (r.cat || "").trim().toUpperCase();

export const carryStyles = (prev, next) => {
  const map = {};
  allRows(prev).forEach((r) => { if (r.s && !map[styleKey(r)]) map[styleKey(r)] = r.s; });
  if (!Object.keys(map).length) return next;
  const put = (r) => (r.s || !map[styleKey(r)] ? r : { ...r, s: map[styleKey(r)] });
  return {
    ...next,
    top: next.top ? { ...next.top, rows: (next.top.rows || []).map(put) } : next.top,
    columns: (next.columns || []).map((c) => ({ ...c, rows: (c.rows || []).map(put) })),
    footer: (next.footer || []).map(put),
  };
};

const DATE_RE = /\d{1,2}\/\d{1,2}/g;
const datesOf = (p) => new Set([p.top?.rows?.length ? p.top.header : "", ...(p.columns || []).filter((c) => c.rows?.length).map((c) => c.header)].flatMap((h) => (h || "").match(DATE_RE) || []));
const firstWord = (h) => (h || "").trim().split(/\s+/)[0].toUpperCase();
const sameMatch = (a, b) => styleKey(a) === styleKey(b) && (a.match || "").trim().toUpperCase() === (b.match || "").trim().toUpperCase();

export const keepManualRows = (prev, next) => {
  const old = datesOf(prev);
  const sameWeek = [...datesOf(next)].some((d) => old.has(d));
  if (!sameWeek) return { poster: next, kept: 0 };
  let kept = 0;
  const add = (rows, extra) => {
    const fresh = extra.filter((m) => !rows.some((r) => sameMatch(r, m)));
    kept += fresh.length;
    return [...rows, ...fresh];
  };
  const manual = (rows) => (rows || []).filter((r) => r.manual);
  const poster = {
    ...next,
    top: { ...next.top, rows: add(next.top?.rows || [], manual(prev.top?.rows)) },
    columns: (next.columns || []).map((c, i) => {
      const src = (prev.columns || []).find((o) => firstWord(o.header) && firstWord(o.header) === firstWord(c.header)) || prev.columns?.[i];
      return { ...c, rows: add(c.rows || [], manual(src?.rows)) };
    }),
    footer: add(next.footer || [], manual(prev.footer)),
  };
  if (poster.top.rows.length) poster.top.show = true;
  return { poster, kept };
};
